<template>
  <div class="dummy">
    <!-- eslint-disable  -->
    <h4 class="mb-0 mt-0 ml-4">
      Administration
    </h4>
  <b-card  class="mb-0 mt-0" no-body>
    <b-tabs class="mb-0 mt-0" card ref="tabs3">
      <!-- ------------------------------------------------------------------Companies layout 3----------------------------------------------------------------------------------------------------  -->
      <b-tab class="mb-0 mt-0" title="Companies">
        <template v-slot:title>
          <div class="h6 mb-0" style="text-align: center" @click="selectedItem=null; refreshData('updatecompany')">
            <b-icon icon="building"></b-icon><br>Companies
          </div>                   
        </template>  
        <b-row class="w-100">
          <b-col class="mt-0 mb-1">
            <b-input-group class="mt-0 mb-1 w-25">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input v-model="filterCompanies"  type="search"  placeholder="Filter here..." debounce="300"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2">
            <span style="font-style: italic;">NOTE: Click or touch a record to edit it's content</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <b-table 
              ref="selectableTable"
              striped 
              hover 
              small
              sticky-header
              style="max-height: 1500px;"
              :select-mode="selectMode"
              responsive="sm"
              :current-page="currentPageCompanies" 
              :per-page="perPage17" 
              selectable
              :busy.sync="isBusyCompanies"
              :items="dataCompanies"
              :filter="filterCompanies"
              :filter-included-fields="filterOnCompanies"
              @row-clicked="onRowClickedLayout2"        
            >
            </b-table>
            <div style="width: 100%;">
              <b-pagination :total-rows="dataCompanies.length" :per-page="perPage17" v-model="currentPageCompanies"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"       
              />
            </div>
          </b-col>            
          <b-col cols="3">
            <b-card v-if="selectedItem" class="h-100">
              <h4 class="mb-0 mt-0">Edit Company #{{selectedItem.id}} - {{selectedItem.name}}</h4>
                <b-row class="w-100">
                  <b-col> 
                    <b-form>
                      <label class="mt-1 mb-0 p-0">Name:</label><b-form-input v-model="selectedItem.name"   required        class="m-0 pl-2 w-100" placeholder="Name"       @change="sendUpdate( 'updatecompany', selectedItem.id, { 'name':     selectedItem.name } )" />
                      <label class="mt-1 mb-0 p-0">Address 1:</label><b-form-input v-model="selectedItem.address1"  class="m-0 pl-2 w-100" placeholder="Address 1" @change="sendUpdate( 'updatecompany', selectedItem.id, { 'address1': selectedItem.address1 } )" />
                      <label class="mt-1 mb-0 p-0">Address 2:</label><b-form-input v-model="selectedItem.address2"  class="m-0 pl-2 w-100" placeholder="Address 2" @change="sendUpdate( 'updatecompany', selectedItem.id, { 'address2': selectedItem.address2 } )" />
                      <label class="mt-1 mb-0 p-0">City:</label><b-form-input v-model="selectedItem.city"     class="m-0 pl-2 w-75" placeholder="City"             @change="sendUpdate( 'updatecompany', selectedItem.id, { 'city':     selectedItem.city } )" />
                      <label class="mt-1 mb-0 p-0">State:</label><b-form-input v-model="selectedItem.state"    class="m-0 pl-2 w-25" placeholder="State"           @change="sendUpdate( 'updatecompany', selectedItem.id, { 'state':    selectedItem.state } )" />
              
                      <label class="mt-1 mb-0 p-0">Postal Code:</label><b-form-input v-model="selectedItem.zip" required class="m-0 pl-2 w-50"  placeholder="Zip"       @change="sendUpdate( 'updatecompany', selectedItem.id, { 'zip':      selectedItem.zip } )" />
                      <label class="mt-1 mb-0 p-0">Country:</label><b-form-input v-model="selectedItem.country"  class="m-0 pl-2 w-25" placeholder="Country"       @change="sendUpdate( 'updatecompany', selectedItem.id, { 'country':  selectedItem.country } )" />
                      <label class="mt-1 mb-0 p-0">Phone Number:</label><b-form-input v-model="selectedItem.phoneno"  required class="m-0 pl-2 w-50" placeholder="Phone"    @change="sendUpdate( 'updatecompany', selectedItem.id, { 'phoneno':  selectedItem.phoneno } )" />
                    <b-button class="mt-4 text-right" style="display: block; float: right;" variant="warning" data-backdrop="false" @click="selectedItem=null"><b-icon icon="x-circle" aria-hidden="true"></b-icon> Cancel</b-button>
                  </b-form>
                </b-col>
              </b-row>           
            </b-card>
            <b-card v-else class="h-100">
              <h4 class="mb-0 mt-0">New Company</h4>
              <b-form @submit="onSubmit('createcompany', companyForm)" @reset="onReset">
      
                <label class="mt-1 mb-0 p-0">Name:</label><b-form-input class="m-0 pl-2 w-50" v-model="companyForm.name" type="text" placeholder="Enter Company Name"  required></b-form-input>
                <label class="mt-1 mb-0 p-0">Address 1:</label><b-form-input class="m-0 pl-2 w-100" v-model="companyForm.address1" type="text" placeholder="Enter Address line 1"></b-form-input>
                <label class="mt-1 mb-0 p-0">Address 2:</label><b-form-input class="m-0 pl-2 w-100" v-model="companyForm.address2" type="text" placeholder="Enter Address line 2"></b-form-input>
                <b-row class="w-100">
                  <b-col class="w-75">
                    <label class="mt-1 mb-0 p-0">City:</label><b-form-input class="m-0 pl-2 w-100" v-model="companyForm.city" type="text" placeholder="City"></b-form-input>
                  </b-col>
                  <b-col class="w-25">
                    <label class="mt-1 mb-0 p-0">State:</label><b-form-input class="m-0 pl-2 w-50" v-model="companyForm.state" type="text" placeholder="State (US only)"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="w-100">
                  <b-col class="w-75">
                    <label class="mt-1 mb-0 p-0">Postal Code:</label><b-form-input class="m-0 pl-2 w-100" v-model="companyForm.zip" type="text" placeholder="Postal Code"></b-form-input>
                  </b-col>
                  <b-col class="w-25">
                    <label class="mt-1 mb-0 p-0">Country:</label><b-form-input class="m-0 pl-2 w-50" v-model="companyForm.country" type="text" placeholder="Country"></b-form-input>
                  </b-col>
                </b-row>
                <label class="mt-1 mb-0 p-0">Phone:</label><b-form-input class="m-0 pl-2 w-50" v-model="companyForm.phoneno" type="text" placeholder="Phone Number"></b-form-input>

                <b-button class="mt-4 mr-3" type="submit" variant="primary">Submit</b-button>
                <b-button class="mt-4 mr-3" type="reset" variant="danger">Reset</b-button>
              </b-form>
            </b-card>
          </b-col>           
        </b-row> 
      </b-tab>
      <!-- -----------------------------------------------------------------Users layout 3---------------------------------------------------------------------------------------------------------  -->
      <b-tab class="mb-0 mt-0" title="Users">
        <template v-slot:title>
          <div class="h6 mb-0" style="text-align: center" @click="selectedItem=null; refreshData('updateuser')">
            <b-icon icon="people-fill"></b-icon><br>Users
          </div>
        </template>                   
        <b-row class="w-100">
          <b-col class="mt-0 mb-1">
            <b-input-group class="mb-2 w-25">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input  v-model="filterUsers"  type="search"  placeholder="Filter here..." debounce="300"></b-form-input>
            </b-input-group>            
          </b-col>
        </b-row> 
        <b-row>
          <b-col class="mb-2">
            <span style="font-style: italic;">NOTE: Click or touch a record to edit it's content</span>
          </b-col>
        </b-row>
        <b-row class="w-100">
          <b-col cols="9">
            <b-table 
              v-if="renderComponent"        
              ref="selectableTable"
              striped 
              hover 
              small
              sticky-header
              style="max-height: 1500px;"
              :select-mode="selectMode"
              responsive="sm"
              :current-page="currentPageUsers" 
              :per-page="perPage17" 
              selectable          
              :busy.sync="isBusyUsers"
              :items="dataUsers"
              :fields="fieldsUsers"
              :filter="filterUsers"
              :filter-included-fields="filterOnUsers"
              @row-clicked="onRowClickedLayout2"        
            >
            </b-table>
            <b-pagination :total-rows="dataUsers.length" :per-page="perPage17" v-model="currentPageUsers" 
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"        
            />             
          </b-col>
          <b-col cols="3">
            <b-card v-if="selectedItem" class="h-100">
              <h4>Edit User #{{ selectedItem.id }} - {{ selectedItem.login }} ({{ selectedItem.first_name }} {{ selectedItem.last_name }})</h4>
              <b-form>
                    <label class="mt-1 mb-0 p-0">Company: Current-> {{ selectedItem.company }}</label>
                      <b-form-select v-model="selectedItem.companyid" :options="dataCompaniesDropDown" value="selectedItem.companyid"                               @change="sendUpdate( 'updateuser', selectedItem.id, {'companyid': selectedItem.companyid} )" />
                    <label class="mt-1 mb-0 p-0">Login:</label><b-form-input v-model="selectedItem.login"           class="m-0 pl-2 w-50"  placeholder="Login"      @change="sendUpdate( 'updateuser', selectedItem.id, {'login': selectedItem.login} )" />
                    <label class="mt-1 mb-0 p-0">Email:</label><b-form-input v-model="selectedItem.email"           class="m-0 pl-2 w-100" placeholder="Email"      @change="sendUpdate( 'updateuser', selectedItem.id, {'login': selectedItem.email} )" disabled />
                    <label class="mt-1 mb-0 p-0">Password:</label><b-form-input v-model="selectedItem.password"     class="m-0 pl-2 w-100" placeholder="Password" type="password"  @change="sendUpdate( 'updateuser', selectedItem.id, {'password':  selectedItem.password} )"  />
                    <label class="mt-1 mb-0 p-0">First Name:</label><b-form-input v-model="selectedItem.first_name" class="m-0 pl-2 w-75"  placeholder="First Name" @change="sendUpdate( 'updateuser', selectedItem.id, {'first_name': selectedItem.first_name} )" />
                    <label class="mt-1 mb-0 p-0">Last Name:</label><b-form-input v-model="selectedItem.last_name"   class="m-0 pl-2 w-75"  placeholder="Last Name"  @change="sendUpdate( 'updateuser', selectedItem.id, {'last_name': selectedItem.last_name} )" />
                    <label class="mt-1 mb-0 p-0">Permissions:  (current ID value: {{ selectedItem.permid }})</label>
                      <b-form-select v-model="selectedItem.permid" :options="dataUserRolesDropDown" value="selectedItem.permid" @change="sendUpdate( 'updateuser', selectedItem.id, {'permid':  selectedItem.permid} )" />
              </b-form>
              <!-- SHOW DEVICES FOR USER -->
              <b-button class="mt-4 mr-3" variant="info" v-b-toggle.collapse-4 @click="getDevicesForUser( 'userid', selectedItem.id )"><b-icon icon="card-list"></b-icon> Show Devices</b-button>
              <b-button class="mt-4 float-right" variant="success" v-b-modal.showMiniDeviceListLayout3><b-icon icon="plus-square"></b-icon> Add Device</b-button>
              <b-modal id="showMiniDeviceListLayout3" size="lg" centered scrollable title="Add Device(s) to this User" ok-only ok-variant="secondary" :hide-footer="true">    
                <b-input-group class="mb-2 w-50">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input  v-model="filterDevices"  type="search"  placeholder="Filter here..." debounce="300"></b-form-input>
                  <!-- <b-input-group-append><b-button  :disabled="!filterDevices" @click="filterUsers = ''">Clear</b-button></b-input-group-append> -->
                </b-input-group>                     
                <b-table
                  striped
                  small
                  sticky-header     
                  :select-mode="selectMode"
                  responsive="sm"
                  selectable                        
                  :busy.sync="isBusyDevicesForUser"
                  :items="dataDevices"
                  :fields="fieldsDevicesForUser"
                  :filter="filterDevices"
                  :filter-included-fields="filterOnDevices"
                >
                  <template #cell(actions)="adddevicerow">
                    <b-button size="sm" variant="success" @click="assignDeviceToUser( adddevicerow.item.id, selectedItem.id )" class="ml-2 mr-1"><b-icon icon="plus"></b-icon></b-button>
                  </template>
                </b-table>
              </b-modal>
              <span class="mt-2 mb-0 ml-3 p-0 text-danger" v-show="isBusyDevicesForUser" ><strong>Loading...</strong></span>
              <b-collapse id="collapse-4" class="mt-3">
                  <b-table
                    striped
                    small
                    sticky-header     
                    style="max-height: 1500px;"
                    :select-mode="selectMode"
                    responsive="md"
                    bordered
                    :current-page="currentPageDevicesForUser" 
                    :per-page="perPageDevicesForUser" 
                    selectable                      
                    :busy.sync="isBusyDevicesForUser"
                    :items="dataDevicesForUser"
                    :fields="fieldsDevicesForUser"
                  >
                    <!-- :fields="fieldsDevicesForUser" -->
                    <template #cell(actions)="devicerow">
                      <b-button v-show="showDevicesList" size="sm" variant="danger" @click="deleteDeviceFromUser( devicerow.item.id, selectedItem.id ) " class="ml-2 mr-1"><b-icon icon="x-circle"></b-icon></b-button>
                    </template>
                  </b-table>
                <b-pagination :total-rows="dataDevicesForUser.length" :per-page="perPageDevicesForUser" v-model="currentPageDevicesForUser" 
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                />
            </b-collapse>
            <b-button class="mt-4 text-right" style="display: block; float: right;" variant="warning" data-backdrop="false" @click="selectedItem=null"><b-icon icon="x-circle" aria-hidden="true"></b-icon> Cancel</b-button>
            </b-card>
            <b-card v-else class="h-100">
              <h4>New User</h4>
              <b-form @submit="onSubmit('createuser', userForm)" @reset="onReset">
        
                    <label class="mt-1 mb-0 p-0">Company:</label><b-form-select v-model="userForm.companyid" :options="dataCompaniesDropDown" />
                    <label class="mt-1 mb-0 p-0">Login:</label><b-form-input v-model="userForm.login" type="text" placeholder="Enter Desired Login Name"></b-form-input>
                    <label class="mt-1 mb-0 p-0">Email:</label><b-form-input v-model="userForm.email" type="text" placeholder="Enter A Valid Email" disabled></b-form-input>
                    <label class="mt-1 mb-0 p-0">Password:</label><b-form-input v-model="userForm.password" type="text" :disabled='false' placeholder="Enter Password"></b-form-input>

                    <label class="mt-1 mb-0 p-0">First Name:</label><b-form-input v-model="userForm.first_name" type="text" placeholder="First Name"></b-form-input>
                    <label class="mt-1 mb-0 p-0">Last name:</label><b-form-input v-model="userForm.last_name" type="text" placeholder="Last Name"></b-form-input>
                    <label class="mt-1 mb-0 p-0">Permission ID:</label><b-form-select v-model="userForm.permid" :options="dataUserRolesDropDown" />

                <b-button class="mt-4 mr-3" type="submit" variant="primary">Submit</b-button>
                <b-button class="mt-4 mr-3" type="reset" variant="danger">Reset</b-button>
              </b-form>
            </b-card>
          </b-col>
        </b-row>            
      </b-tab>
      <!-- -------------------------------------------------------------Devices layout 3-----------------------------------------------------------------------------------------------------------  -->
      <b-tab class="mb-0 mt-0" title="Devices" active>
        <template v-slot:title>
          <div class="h6 mb-0" style="text-align: center" @click="selectedItem=null; refreshData('updatedevice')">
            <b-icon icon="gear-wide-connected"></b-icon><br>Devices
          </div>
        </template>  

        <b-row class="w-100">
          <b-col cols="9">

        <b-row class="w-100">
          <b-col class="mt-0 mb-1">
            <b-input-group class="mb-2 w-25">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input  v-model="filterDevices"  type="search"  placeholder="Filter here..." debounce="300"></b-form-input>
            </b-input-group>            
          </b-col>
        </b-row>                
        <b-row>
          <b-col class="mb-2">
            <div style="display: inline-block;" class="ml-4 w-50">
              <span style="font-style: italic;">NOTE: Click or touch a record to edit it's content</span>
            </div>
            <div style="display: inline-block; float: right;"><span>Device State Key: </span>
              <!-- <b-button small class="ml-2" size="sm" variant="light">Created</b-button> -->
              <b-button small class="ml-2" size="sm" style="background-color: #C3E6CB; color: black;">Active</b-button>
              <b-button small class="ml-2" size="sm" style="background-color: #BEE5EB; color: black;">Demo</b-button>
              <b-button small class="ml-2" size="sm" style="background-color: #C6C8CA; color: black;">Passive</b-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
          <!-- <b-col cols="9"> -->
            <b-table
              ref="selectableTable"
              small
              sticky-header
              style="max-height: 1500px;"
              responsive="sm"
              :current-page="currentPageDevices" 
              :per-page="perPage17" 
              :busy.sync="isBusyDevices"
              :items="dataDevices"
              :fields="fieldsDevices"
              :filter="filterDevices"
              :filter-included-fields="filterOnDevices"
              :tbody-tr-class="rowStatus"
              selectable select-mode="single"
              @row-clicked="onRowClickedLayout2"        
            >
              <template #cell(online)="onlineCell">
                <div v-if="onlineCell.item.online > 0"><b-icon class="h4 mt-0 mb-0" icon="check-circle-fill" variant="success"></b-icon></div>
              </template>
              <template #cell(active)="activeCell">
                <div v-if="activeCell.item.active > 0"><b-icon class="h4 mt-0 mb-0" icon="check-circle-fill" variant="success"></b-icon></div>
              </template>             
              <template #cell(ws)="wsCell">
                <div v-if="wsCell.item.ws == 'WSSim'"><b-icon class="h4 mt-0 mb-0" icon="cloud-check-fill" variant="primary"></b-icon></div>
              </template>   
            </b-table>
            <div style="width: 100%;">
              <b-pagination :total-rows="dataDevices.length" :per-page="perPage17" v-model="currentPageDevices"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"       
              />
            </div>
          </b-col>

        </b-row>
          
          </b-col>
          <b-col cols="3" class="mt-0 pt-0 h-200" id="blinkBox">

          <!-- ---------- Device Edit ----------------- -->

            <b-card v-if="selectedItem" class="mt-0 pt-0 h-200">
              <h4 class="mt-0 pt-0">Edit Device - #{{selectedItem.id}} {{selectedItem.typename}}</h4>
              <b-form>
                <h6 class="mt-1 mb-0 p-0">Device State</h6>       
                  <b-form-select v-model="selectedItem.state" class="m-0 pl-2 w-50" :options="dataDeviceStateDropDown" type="number" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'state': selectedItem.state } )" />
                <h6 class="mt-1 mb-0 p-0">Serial Number:</h6><b-form-input class="m-0 pl-2 w-100" v-model="selectedItem.serno" type="text" placeholder="Serial" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'serno': selectedItem.serno } )" />
                <h6 class="mt-1 mb-0 p-0">Description:</h6><b-form-input class="m-0 pl-2 w-100" v-model="selectedItem.description" type="text" placeholder="Description" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'description': selectedItem.description } )" />
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Subscription:</h6><b-form-input class="m-0 pl-2 w-100" v-model="selectedItem.si" type="text" placeholder="Subscription" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'si': selectedItem.si } )" />
                  </b-col>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Phone Number:</h6><b-form-input class="m-0 pl-2 w-100" v-model="selectedItem.phoneno" type="text" placeholder="Phone Number" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'phoneno': selectedItem.phoneno } )" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Device Type</h6>       
                      <b-form-select class="m-0 pl-2" v-model="selectedItem.typename" :options="dataDeviceTypesDropDownByName" :disabled='true' @change="sendUpdate( 'updatedevice', selectedItem.id, { 'typename': selectedItem.typename } )" />
                  </b-col>
                  <b-col class="w-50">  
                    <h6 class="mt-1 mb-0 p-0">Connection Type</h6> 
                      Current:  {{selectedItem.conntype}}
                      <b-form-select class="m-0 pl-2" 
                        v-model="selected" 
                        :options="dataDeviceConnectionsDropDown" 
                        :value="deviceConnectionValue(selectedItem.conntype)" 
                        @change="sendUpdate( 'updatedeviceadvance', selectedItem.id, { 'conntypeid': selected } )" 
                      />
                  </b-col>
                </b-row>      
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0 w-75">IP Address:</h6><b-form-input v-model="selectedItem.ipaddr" type="text" class="m-0 pl-2" placeholder="IP address" @change="sendUpdate( 'updatedevice', selectedItem.id, { 'ipaddr': selectedItem.ipaddr } )" />
                  </b-col>
                  <b-col class="w-50">  
                    <h6 class="mt-1 mb-0 p-0 w-25">Port:</h6><b-form-input v-model="selectedItem.octrlgport" type="number" class="m-0 pl-2" placeholder="Port"  @change="sendUpdate( 'updatedevice', selectedItem.id, { 'octrlgport': selectedItem.octrlgport } )" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Choose features</h6>
                    <b-form-radio-group name="groupOfRadiosRKD" 
                      v-if="rkdTypes.includes(selectedItem.typename)" :options="deviceSetupRkdOptions" v-model="checkedRKD" stacked
                      @change="updateDeviceFeatures($event, selectedItem.id, selectedItem.dallowance)"
                    />
                    <b-form-radio-group disabled style="color: lightgrey;"
                      v-else :options="deviceSetupTWCOptions" v-model="checkedTWC" stacked
                      @change="updateDeviceFeatures($event, selectedItem.id, selectedItem.dallowance)"
                    />
                  </b-col>
                  <b-col class="w-50">
                    <h6 class="mt-4 mb-0 p-0 text-danger"><b-icon icon="arrow-left" aria-hidden="true"></b-icon> NOTE: Each selection includes features from the one(s) above it.</h6>
                  </b-col>                  
                </b-row>
                <b-row v-if="rkdTypes.includes(selectedItem.typename)">
                  <b-col class="w-50">
                    <h6 class="mt-2 mb-0 p-0">Monitor Delay:</h6>
                      <b-form-input v-model="selectedItem.delay" type="text" class="m-0 pl-2 w-50" placeholder="Delay" @change="sendUpdate( 'updatedeviceadvance', selectedItem.id, { 'delayvalue': selectedItem.delay } )" />
                  </b-col>

                  <b-col class="w-50">
                    <b-form-checkbox
                      id="checkbox-2"
                      class="mt-2"
                      v-model="selectedItem.ws"
                      :value="selectedItem.ws"
                      @change="sendUpdate( 'updatedeviceadvance', selectedItem.id, { 'weatherstation': selectedItem.ws } )"
                    >
                      Weather Station?
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-2 mb-0 p-0">Zip for device</h6>
                    <b-form-input class="m-0 pl-2 w-50" v-model="selectedItem.zip" type="text" placeholder="Zip Code" @change="sendUpdate( 'updatedeviceadvance', selectedItem.id, {'zip': selectedItem.zip} )" />
                  </b-col>
                  <b-col class="w-50">
                    <h6 class="mt-2 mb-0 p-0">Email Subject</h6>                  
                    <b-form-input v-model="selectedItem.emailsubject" type="text" class="m-0 pl-2 w-100" placeholder="Email Subject" @change="sendUpdate( 'updatedeviceadvance', selectedItem.id, { 'emailsubject': selectedItem.emailsubject } )" />
                  </b-col>
                </b-row>
                <b-button class="mt-3 ml-2 text-right float-right" variant="warning" data-backdrop="false" @click="selectedItem=null"><b-icon icon="x-circle" aria-hidden="true"></b-icon> Cancel</b-button>
                <b-button v-if="selectedItem.active > 0" class="mt-3 mr-2 float-right"data-backdrop="false" variant="danger" @click="openMsgBox('Kill the Login Process', selectedItem.active)"><b-icon icon="exclamation-octagon-fill"></b-icon> Kill Login</b-button>
                <b-button v-if="selectedItem.online > 0" class="mt-3 mr-2 float-right"data-backdrop="false" variant="danger" @click="openMsgBox('Kill the Controller Process', selectedItem.online, )"><b-icon icon="exclamation-octagon-fill"></b-icon> Kill Process</b-button>
              </b-form>
            </b-card>

          <!-- ---------- Device New ----------------- -->

            <b-card v-else class="h-100">
              <h4 class="mb-1">New Device</h4>
              <b-form @submit="onSubmit('createdevice', deviceForm)" @reset="onReset">
                <h6 class="mt-4 mb-0 p-0">Serial Number:</h6><b-form-input class="m-0 pl-2 w-100" v-model="deviceForm.serno" type="text" placeholder="Serial Number" />
                <h6 class="mt-1 mb-0 p-0">Description:</h6><b-form-input class="m-0 pl-2 w-100" v-model="deviceForm.description" type="text" placeholder="Description" />
                <h6 class="mt-1 mb-0 p-0">Phone Number:</h6><b-form-input class="m-0 pl-2 w-100" v-model="deviceForm.phoneno" type="text" placeholder="Phone Number" />
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Device Type</h6>       
                    <b-form-select v-model="deviceForm.devtypeid" class="m-0 pl-2" :options="dataDeviceTypesDropDown" />
                  </b-col>
                  <b-col class="w-50">  
                    <h6 class="mt-1 mb-0 p-0">Connection Type</h6>
                    <b-form-select v-model="deviceForm.conntypeid" class="m-0 pl-2" :options="deviceConnectionDropDown" />
                  </b-col>
                </b-row>  
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">IP Address:</h6><b-form-input v-model="deviceForm.ipaddr" type="text" class="m-0 pl-2 w-100" placeholder="IP address" />
                  </b-col>
                  <b-col class="w-50">  
                    <h6 class="mt-1 mb-0 p-0">Port:</h6><b-form-input v-model="deviceForm.octrlgport" type="number" class="m-0 pl-2 w-100" />
                  </b-col>
                </b-row>  
                <b-row>
                  <b-col class="w-50">
                    <h6 class="mt-1 mb-0 p-0">Choose features</h6>
                      <b-form-radio-group  
                        v-if="rkdTypesByID.includes(deviceForm.devtypeid)"
                        v-model="deviceForm.featureOption"  
                        :options="deviceSetupRkdOptions"
                        name="device-setup"
                      >
                      </b-form-radio-group>
                      <b-form-radio-group        
                        v-else
                        v-model="deviceForm.featureOption"  
                        :options="deviceSetupTWCOptions"
                        name="device-setup"
                      >
                      </b-form-radio-group>
                  </b-col>
                  <b-col class="w-50">
                    <h6 class="mt-4 mb-0 p-0 text-danger"><b-icon icon="arrow-left" aria-hidden="true"></b-icon> NOTE: Each selection includes features from the one(s) above it.</h6>
                  </b-col>                  
                </b-row>                                  
                <hr>
                <section v-if="rkdTypesByID.includes(deviceForm.devtypeid)">
                  <h6 class="mt-1 mb-0 p-0">Monitor Delay (mins):</h6>
                  <b-form-input v-model="deviceForm.delayvalue" type="number" class="m-0 pl-2 w-25" placeholder="Delay" />
                  <!-- <h6 class="mt-1 mb-0 p-0">Act as Weather Station:</h6> -->
                  <b-form-checkbox
                    class="mt-3"
                    id="checkbox-1"
                    v-model="deviceForm.weatherstation"
                    name="checkbox-1"
                    value=true
                    unchecked-value=false
                  >
                    Act as Weather Station - State: <strong>{{ deviceForm.weatherstation }}</strong>
                  </b-form-checkbox>

                </section>
                <hr>
                <h6 class="mt-1 mb-0 p-0">Zip Code for device</h6>
                <b-form-input class="m-0 pl-2 w-50" v-model="deviceForm.zip" type="text" placeholder="Zip Code" />

                <b-button class="mt-4 mr-3" type="submit" variant="primary">Submit</b-button>
                <b-button class="mt-4 mr-3" type="reset" variant="danger">Reset</b-button>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab class="mb-0 mt-0" title="" disabled>
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null"></div>
        </template>       
      </b-tab>  
      <b-tab class="mb-0 mt-0" title="Export">
        <template v-slot:title>
          <div class="h6 mb-0" style="text-align: center" @click="selectedItem=null">
            <b-icon icon="download"></b-icon><br>Export
          </div>
        </template>         
        <b-row class="w-100">
          <b-col class="w-25">
              <span class="m-2">{{ getTimeStamp() }}</span><br>
                <b-button class="mt-2 mr-4" variant="primary" @click="csvExporter(dataCompanies, 'Companies')"><b-icon icon="building"></b-icon> Export Companies</b-button>
                <b-button class="mt-2 mr-4" variant="primary" @click="csvExporter(dataUsers, 'Users')"><b-icon icon="people-fill"></b-icon> Export Users</b-icon></b-button>
                <b-button class="mt-2 mr-4" variant="primary" @click="csvExporter(dataDevices, 'Devices')"><b-icon icon="gear-wide-connected"></b-icon> Export Devices</b-button>
          </b-col>
          <b-col class="w-75">
            <b-img-lazy v-bind="exportImageProps" :src="getLoremIpsumImage()" alt="irrigation-related image"></b-img-lazy>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab class="mb-0 mt-0" title="" disabled>
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null"></div>
        </template>       
      </b-tab>
      <b-tab class="mb-0 mt-0" title="" disabled>
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null"></div>
        </template>       
      </b-tab>
      <b-tab class="mb-0 mt-0" title="" disabled>
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null"></div>
        </template>       
      </b-tab>
      <b-tab class="mb-0 mt-0" title="" disabled>
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null"></div>
        </template>       
      </b-tab>
      <b-tab class="mb-0 mt-0" title="Active Devices"> 
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null">
            <b-icon icon="hdd-network"></b-icon><br>Active Devices
          </div>
        </template>     
        <b-row class="w-100">
          <table class="table table-striped table-responsive-md btn-table">
            <tr>
              <th>timestamp - last com time</th>
              <th>id</th>
              <th>type</th>
              <th>description</th>
              <th>Online / Active</th>
              <th>Active Process ID</th>
              <th>Actions</th>
            </tr>
            <tr v-for="device in dataDevices" v-if="device.active > 0">
              <td>{{ new Date(device.lastcomtime).toLocaleString() }}</td>
              <td>{{ device.id }}</td>
              <td>{{ device.typename }}</td>
              <td>{{ device.description }}</td>
              <td>
                <div v-if="device.online > 0" style="display: inline-block"><p class="h2 mb-2"><b-icon icon="check-circle-fill" variant="success">&nbsp;</b-icon></p></div>
                <div v-else style="display: inline-block"><p class="h2 mb-2"><b-icon icon="check-circle" variant="secondary"></b-icon></p></div>&nbsp;&nbsp;
                <div v-if="device.active > 0" style="display: inline-block"><p class="h2 mb-2"><b-icon icon="check-circle-fill" variant="success">&nbsp;</b-icon></p></div>
                <div v-else style="display: inline-block"><p class="h2 mb-2"><b-icon icon="check-circle" variant="secondary"></b-icon></p></div>
              </td>
              <td>{{ device.active }}</td>
              <td>
                <b-button v-if="device.active > 0" class="mt-3 mr-2 float-right"data-backdrop="false" variant="danger" @click="openMsgBox('Login', device.active, device.id, )"><b-icon icon="exclamation-octagon-fill"></b-icon> Kill Login</b-button>&nbsp;
                <b-button v-if="device.online > 0" class="mt-3 mr-2 float-right"data-backdrop="false" variant="danger" @click="openMsgBox('Controller', device.online)"><b-icon icon="exclamation-octagon-fill"></b-icon> Kill Controller</b-button>&nbsp;
              </td>
            </tr>
          </table>
        </b-row>
      </b-tab>
      <b-tab class="mb-0 mt-0" title="Pretty Lights"> 
        <template v-slot:title>
          <div class="h6 mb-0 ml-5 mr-5" style="text-align: center" @click="selectedItem=null">
            <b-icon icon="lightbulb"></b-icon><br>Pretty Lights
          </div>
        </template>     
        <b-row class="w-100">
          <div v-for="device in dataDevices">
            <div v-if="device.state == 2" class="activeMonitorBox mb-0 mt-1 mr-0">
              <div style="display: inline-block">{{ device.id }}&nbsp;</div>
              <div v-if="device.online > 0" style="display: inline-block"><b-icon icon="check-circle-fill" variant="success"></b-icon></div>
              <div v-else style="display: inline-block"><b-icon icon="check-circle" variant="secondary"></b-icon></div>
              <div v-if="device.active > 0" style="display: inline-block"><b-icon icon="check-circle-fill" variant="success"></b-icon></div>
              <div v-else style="display: inline-block"><b-icon icon="check-circle" variant="secondary"></b-icon></div>
            </div>
          </div>
        </b-row>
      </b-tab>              
    </b-tabs>
  </b-card>        
    <!-- eslint-enable  -->                   
  </div>
</template>

<script>

import {SocketHandler, LifeCycle, MicroService} from '@/assets/javascript/mixins/Mixins'
// import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'


export default {
  name: 'Admin',
  components: {
    // 'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    // hold over from other components in case we need to interact with rest of webapp.  -jimm 12.mar.2021
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      renderComponent: true,
      tabIndex: null,
      tabIndex2: null,

      value: null,
      //main 'data stores' for each section
      dataCompanies: [],
      dataUsers: [],
      dataDevices: [],
      dataDevicesForUser: [],
      weatherstation: [],
      dataWeatherStations: [],
      dataZips: [],
      dataDelays: [],
      dataEmailSubjects: [],

      active_fields: ['lastcomtime', 'id', 'typename', 'description'],

      // dropdowns
      dataCompaniesDropDown: [],
      dataDeviceStateDropDown: [],
      dataUserRolesDropDown: [],
      dataDeviceTypesDropDown: [],
      dataDeviceTypesDropDownByName: [],
      devicetypesDD: [],
      deviceConnectionDropDown: [
        { text: 'Please choose', value: 0},
        { text: 'CEAM',          value: 1},
        { text: 'CWAM',          value: 2},
        { text: 'CRAM',          value: 3},
        { text: 'LAN',           value: 4},
        { text: 'AirGate',       value: 5},
        { text: 'Teltonika',     value: 6},
      ],

      // connection massaging of dropdown or filtering (NOTE: re-factor templates to use deviceConnectionDropDown *only* )
      // deviceConnectionTypes: ['Please choose', 'CEAM', 'CWAM', 'CRAM', 'LAN', 'AirGate', 'Teltonika'],

      // filter initializing
      filterCompanies: null,      
      filterUsers: null,
      filterDevices: null,

      // filter for filter-included-fields prop
      filterOnCompanies: [],
      filterOnUsers: [],
      filterOnDevices: [],

      selectMode: 'single',
      // selected: null,
      isBusyDevices: false,
      isBusyUsers: false,
      isBusyCompanies: false,
      isBusyDevicesForUser: false,

      // pagination initializing
      currentPageCompanies: 1,
      currentPageUsers: 1,
      currentPageDevices: 1,
      currentPageDevicesForUser: 1,
      perPage: 15,
      perPage17: 17,
      perPageDevicesForUser: 10,

      // new entry initializing
      companyForm: {},
      userForm: {},
      deviceForm: {},
      show: true,

      // collapsing form flags for new/edit
      showCompanyForm: false,
      showUserForm: false,
      showDeviceForm: false,
      showDevicesList: null,

      // layout 1 collapsing section caret flag
      flipCompaniesCaret: false,
      flipUsersCaret: false,
      flipDevicesCaret: false,

      // splitting up devicetypes for pattern matching (f.ex. showing rkd-type options when choosing a rkd family type)
      rkdTypesByID: [1, 208, 35, 32, 207, 50, 51, 140, 149, 206, 215],
      rkdTypes: ['rkd', 'rkd-plus', 'rkd-o', 'rks', 'rks-plus', 'gtc-d', 'gtc-s', 'nlc-d', 'nlc-s', 'ltd', 'ranger-4000d'],
      twcTypes: ['twc', 'aic', 'twc nv ag', 'twc nv web', 'nls-d', 'nlc-s', 'ltd', 'grower-6000d-10', 'grower-6000d-15'],
      wsTypes:  ['irrisoft ws', 'davis ws'],
      srcOnlyTypes: ['ranger-4000d', 'grower-6000d-10', 'grower-6000d-15' ],
      checkedRKD: null,
      checkedTWC: null,

      deviceSetupRkdOptions: [
        { text: "Alarm + Daily ET",   value: 1},
        { text: "Remote Access",      value: 2},
        { text: "Monitor Overview",   value: 3},
        { text: "Program Start/Stop", value: 4},
        { text: "Station Start/Stop", value: 5}
      ],
      deviceSetupTWCOptions: [
        { text: "Remote Access",   value: 6},
        { text: "Water Usage",     value: 7},
        { text: "Flow Monitoring", value: 8}
      ],

      deviceState: [
        { text: "None",     value: 0 },
        { text: "Created",  value: 1 },
        { text: "Active",   value: 2 },
        { text: "Demo",     value: 3 },
        { text: "Passive",  value: 4 },
        { text: "Retired",  value: 5 }
      ],

      deviceStateRowColor: [
        '',                       // covering zero index
        '',                       // state 1 'Created'
        'table-success',          // state 2 'Active'
        'table-info',             // state 3 'Demo'
        'table-dark text-muted',  // state 4 'Passive'
        ''                        // state 5 'Retired'
      ],

      //converting radio-button options into array of values for database
      deviceSetupArray: [
        // default (no choice made)
        { remaccess: 0, dallowance: null, menuvisible: 0 },  //  filler for [0] position in array ** used to help set indexing properly **
        // rkd     
        { remaccess: 0, dallowance: 32767,      dallowanceUpperHex: '0000', menuvisible: 1 },  // Alarm + ET
        { remaccess: 1, dallowance: 32767,      dallowanceUpperHex: '0000', menuvisible: 1 },  // Remote Access
        { remaccess: 1, dallowance: 2147254271, dallowanceUpperHex: '7ffc', menuvisible: 1 },  // Monitor Overview
        { remaccess: 1, dallowance: 2147319807, dallowanceUpperHex: '7ffd', menuvisible: 1 },  // Program Start / Stop
        { remaccess: 1, dallowance: 2147450879, dallowanceUpperHex: '7fff', menuvisible: 1 },  // Station Start / Stop
        // twc
        { remaccess: 1, dallowance: null, menuvisible: 0 },  // Remote Access
        { remaccess: 1, dallowance: null, menuvisible: 1 },  // Water Usage
        { remaccess: 1, dallowance: null, menuvisible: 3 },  // Flow Monitoring
      ],

      fieldsUsers: [
        { key: 'id' },
        { key: 'company', label: 'Company' },
        { key: 'login', label: 'Login' },
        { key: 'first_name',label: 'First Name' },
        { key: 'last_name',label: 'Last Name' },
        { key: 'description',label: 'Role' },
      ],
      fieldsDevices: [
        { key: 'id', label: 'ID' },
        // { key: 'state', label: 'State' },
        { key: 'serno', label: 'Serial Number' },
        { key: 'phoneno', label: 'Phone' },
        { key: 'si', label: 'SI' },
        { key: 'typename', label: 'Device Type' },
        { key: 'description', label: 'Description' },
        { key: 'ipaddr', label: 'IP Address' },
        { key: 'octrlgport', label: 'Port' },
        { key: 'online', label: 'Online', class: 'text-center' },
        { key: 'active', label: 'Active', class: 'text-center' },
        { key: 'conntype', label: 'Connection' },
        { key: 'ws', label: 'WS' }

        // { key: 'pwstate', label: 'Power', class: 'text-center' }
      ],
      fieldsDevicesForUser: [
        { key: 'id', label: 'ID', sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'typename', label: 'Typename', sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'description', label: 'Description', sortable: true, class: 'text-left' },
        { key: 'actions', label: 'Actions', class: 'text-center' }
      ],

      bitMapFill: null,
      selectedItem: null,

      serverResult: [
        { result: 'Match!', variant: 'success' },
        { result: 'No processes matched locally.', variant: 'warning' },
        { result: 'Syntax error in the command line.', variant: 'danger' },
        { result: 'Fatal error: out of memory etc.', variant: 'danger' }
      ],
      exportForm: [],
      exportFormOptions: [
        { text: 'Companies', value: 'companies' },
        { text: 'Users', value: 'users' },
        { text: 'Devices', value: 'devices' }
      ],
      exportImageProps: {
        center: false,
        fluidGrow: true,
        blank: true,
        blankColor: '#bbb',
        width: 1200,
        height: 400,
        class: 'my-5'
      },
      loremIpsumImages: [517, 107, 112, 85, 808, 337, 165],
      process_list: [],
    }
  },
  computed: {
    isDisabled: function(){
      return true
    }    
  },
  watch: {
    SocketMessage(Message) {
      // strip out udp Packet generated "'s around inner data - jimm 08.mar.2021
      var cleanedMessage = JSON.stringify(Message).replace('"{', '{').replace('}"', '}').replace(/\\/g, '')

      Message = JSON.parse(cleanedMessage)
      // console.log(' <-- socket message: ' + JSON.stringify(Message))
      try {
        if(Message && Message.data) {
          switch(Message.data.category) {
            case 'admin':
              switch(Message.data.command) {
                case 'alert':
                  // typical returned response from psql is 'UPDATE 10' => 'UPDATE 1' from psql, and '0' from the bash echo
                  // we just want that last digit to tell us what the return state was (success, no match, syntax error, etc.)    
                  // -jimm 19aug2022              
                  let index = Number(Message.data.data.toString().substr(-1))

                  switch (Message.data.type) {
                    case 'kill_process':
                      this.makeToast('Kill Process reponse from server: ' + this.serverResult[index].result, this.serverResult[index].variant, 'b-toaster-top-right')
                      break
                    case 'reset_active':
                      this.makeToast('Reset Active State reponse from server: ' + this.serverResult[index].result, this.serverResult[index].variant, 'b-toaster-top-right')
                      break
                    default:
                      break
                  }

                  break
                default:
                  break
              }
              break
            case 'Time':
              // console.log('--- got Time')
              this.getDevices()
              break
            default:
              break
          }
          switch (Message.data.type) {
            case 'devicelist':
              // console.log('--- got devicelist')
              this.getDevices()
              // this.getDevicesForUser()
              break
          
            default:
              break
          }
        }
      } catch(err) {
        console.error(err)
      }
    }
  },
  mounted() {
    this.getEmailSubjects()
    this.getZips()
    this.getWeatherStations()
    this.getDelays()

    this.getCompaniesDropdown()
    this.getUserRolesDropdown()
    this.getDeviceTypesDropdown()
    
    this.getDeviceStateDropdown()
    this.getCompanies()
    this.getUsers()
    this.getDevices()
  },
  methods: {

    cellActive(item) {
      return this.deviceState[item.state].text
    },

    rowStatus(item, type) {
      if (!item || type !== 'row') return
      // if (item.state === 2) return 'table-success'
      return this.deviceStateRowColor[item.state]
    },    

    async openMsgBox(boxTitle, processID, deviceID = 0) {
      const value = await this.$bvModal.msgBoxConfirm("Are you sure you wish to Kill the " + boxTitle + " Process for process #" + processID + " ?", {
        title: boxTitle,
        okTitle: 'Yes',
        okVariant: 'success',
        hideHeaderClose: false,
        centered: true
      })
      // console.log(value, processID)
      if(value == true && this.isInt(processID)) {
        this.killProcess(processID)

        if(deviceID > 0) {
          this.resetActive(deviceID)
        }
      } else {
        this.makeToast(processID + ' is not a valid integer!', 'danger', 'b-toaster-top-right')
      }
    },

    killProcess(process_id) {
      // take process_id send to nodeClientServer to have it put to death -jimm 18.jul.2021

      this.SocketMessageSend({
        component: 'Admin',
        command: 'kill_process',
        data: {
          processID: Number(process_id)
        }
      })
    },

    resetActive(device_id) {
      // take device_id send to nodeClientServer to have it rest the database active state for this device -jimm 18.aug.2022

      this.SocketMessageSend({
        component: 'Admin',
        command: 'reset_active',
        data: {
          deviceID: Number(device_id)
        }
      })
    },

    forceRerender() {
      this.renderComponent = false
      this.$nextTick(() => {
          this.renderComponent = true
      })
    },

    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },

    // microservice main calls
    getData( what ) {
      return this.sendMicroServiceRequest({
        method: 'GET',
        url: 'api/authenticated/function/' + what,
      })
      .then( response => response.data[what] )
      .catch( console.error )
    },
    getDataByID( what, id_type = 'id', id = '') {
      return this.sendMicroServiceRequest({
        method: 'GET',
        url: 'api/authenticated/function/' + what + '?' + id_type + '=' + id
      })
      .then( response => response.data[what] )
      .catch( console.error )
    },

    // userland functions that 'extend' the main calls
    getCompaniesDropdown() {
      this.getData( 'getcompaniesdropdown' ).then( companiesDD => {
        this.dataCompaniesDropDown = this.convertToOptions(companiesDD, 'id', 'company')
      })
    },
    getUserRolesDropdown() {
      this.getData( 'getuserrolesdropdown' ).then( userrolesDD => {
        this.dataUserRolesDropDown = this.convertToOptions(userrolesDD, 'id', 'description')
      })      
    },
    getDeviceStateDropdown() {
      this.getData( 'getdevicestatedropdown' ).then( devicestateDD => {
        this.dataDeviceStateDropDown = this.convertToOptions(devicestateDD, 'state', 'name')
      })      
    },
    getDeviceTypesDropdown() {
      this.getData( 'getdevicetypes' ).then( devicetypesDD => {
        this.dataDeviceTypesDropDown = this.convertToOptions(devicetypesDD, 'id', 'typename')
        this.dataDeviceTypesDropDownByName = this.convertToOptions(devicetypesDD, 'typename', 'typename')
        // throwing connections in here too - no sense in making a whole function for it -jimm 20.jul.2021
        this.dataDeviceConnectionsDropDown = this.convertToOptions(this.deviceConnectionDropDown, 'value', 'text')
      })      
      // TODO - limit SRC admin user to *only* Grower and Ranger devices they can add to the database
      // if ( this.store.getData('user.login') == 'srcadm' ) {
      //   this.dataDeviceTypesDropDown =  [{       'id': 1,       'typename': 'grower4000d'     },     {       'id': 3,       'typename': 'ranger400d'     }]
      // }
    },
    getWeatherStations() {
      this.getData( 'getweatherstations' ).then( weatherstations => {
        if( weatherstations !== null ) {
          this.dataWeatherStations = weatherstations
        }
        // this.dataWeatherStations.forEach((item) => item.ws = true)
        // console.log(JSON.stringify(this.dataWeatherStations).substr(this.dataWeatherStations.length - 200))
      })
    },
    getZips() {
      this.getData( 'getzips' ).then( zips => {
        if( zips !== null ) {
          this.dataZips = zips
        }
      })
    },   
    getDelays() {
      this.getData( 'getdelays' ).then( delays => {
        if( delays !== null ) {
          this.dataDelays = delays
        }
      })
    },
    getEmailSubjects() {
      this.getData( 'device_emailsubjects_get' ).then( emailsubjects => {
        if( emailsubjects !== null ) {
          this.dataEmailSubjects = emailsubjects.result
        }
      })
    },
    getRkdDeviceByID(deviceID) {
      var match = this.devicetypesDD.find(obj => obj.id === deviceID)
          // console.log('getRkdDeviceByID()')
    },                      
    getCompanies() {
      this.isBusyCompanies = true
      this.getData( 'getcompanies' ).then( companies => {
        this.isBusyCompanies = false
        this.dataCompanies = companies
      })
    },
    getUsers() {
      this.isBusyUsers = true
      this.getData( 'getusers' ).then( users => {
        this.isBusyUsers = false
        this.dataUsers = users
      })
    },    
    getDevices() {
      this.isBusyDevices = true
      this.getData( 'getdevices' ).then( devices => {
        this.isBusyDevices = false
        this.dataDevices = devices

        // convert and merge the device-related datasets together for easier manipulation
        // TODO: move this out into the methods section??  -jimm 9.jul.2021
        const joinById = ( ...lists ) =>
          Object.values(
            lists.reduce(
              ( idx, list ) => {
                list.forEach( ( record ) => {
                  if( idx[ record.id ] )
                    idx[ record.id ] = Object.assign( idx[ record.id ], record)
                  else
                    idx[ record.id ] = record
                } )
                return idx
              },
              {}
            )
          )

        // merge all data objects  - mutates this.dataDevices so it reactively changes on the table grid) -jimm
        let joined = joinById(this.dataDevices, this.dataZips, this.dataWeatherStations, this.dataDelays, this.dataEmailSubjects) 
        let joined_length = JSON.stringify(joined).length
        // console.log('merge getDevices(), zips, weatherstations, delays, and email subjects')
      })
    },
    getDevicesForUser( id_type, userID ) {
      this.isBusyDevicesForUser = true
      this.getDataByID( 'getdevices', id_type, userID ).then( devicesForUser => {
        // console.log(JSON.stringify(devicesForUser))
        this.isBusyDevicesForUser = false
        this.dataDevicesForUser = devicesForUser
        if(this.dataDevicesForUser == null) {
          this.dataDevicesForUser = [{'description':'No devices for this user'}]
          this.showDevicesList = false
        } else {
          this.showDevicesList = true
        }
        
      })
    },
    sendUpdate(who, what, jsonData) {
      // awesomely cool multi-who/what microservice updater!
      // who = updatecompany, updateuser, updatedevice
      // what = id of item being updated
      // jsonData = JSON formatted key:value pair(s)
      // full api example: 'api/authenticated/function/updatecompany?id=2  (jsonData is in POST request (see below))
      // - jimm 15.mar.2021

      this.sendMicroServiceRequest({
        method: 'POST',
        url: 'api/authenticated/function/' + who + '?id=' + what,
        data: jsonData
      })
      .then((response) => {
        
        if(response) {
          // console.log('MSR <-- sendUpdate(): ' + who + '?id:' + what + ', jsonData: ' + JSON.stringify(jsonData))
          // console.log('MSR --> response: ' + JSON.stringify(response))
          this.makeToast('Record updated!', 'success', 'b-toaster-top-center')

          this.refreshData(who)
        }      
      }).catch(error => {
        console.error('caught! ' + error.message)
        this.makeToast('sendMicroServiceRequest failed - ' + error.message, 'warning', 'b-toaster-top-center')
      }) 
    },
    updateDeviceFeatures(e, ctrlid, old32bit) {
      // save lower 16 bit from controller, compare upper 16 bit, recombine and continue the update
      // console.log('e, this.deviceSetupArray[e].dallowance, old32bit -> ' + e  + ', ' + this.deviceSetupArray[e].dallowance + ', ' + old32bit)

      var new_upper16bit, old_upper16bit, old_lower16bit, new32bit
      
      if (old32bit === null || old32bit <= 10) {
        // must be a TWC, so keep the null value for dallowance
        new32bit = null
      } else {

        // store the 32bit number as 2 16bit hex values
        if(old32bit <= 32767) {
          // if under 16bit, prepend '0000' to the front of the string so that we keep the 32bit order straight
          old_upper16bit = '0000'
          old_lower16bit = old32bit.toString(16)
        } else {
          old_upper16bit = old32bit.toString(16).slice(0,4)
          old_lower16bit = old32bit.toString(16).slice(4)
        }

        // pull new feature value from deviceSetupArray (upper 16bit) and concatenate with lower 16bit value (from controller)
        // then turn it back into a 32bit number for the database.   -jimm 17.aug.2021
        new_upper16bit = this.deviceSetupArray[e].dallowanceUpperHex
        new32bit = parseInt('0x' + new_upper16bit + old_lower16bit)
      }

      // console.log(' ******** OLD Feature Choice  ' + old_upper16bit + '-' + old_lower16bit)
      // console.log(' ******** NEW Feature Choice  ' + new_upper16bit + '-' + old_lower16bit)

      let jsonData = { 'remaccess': this.deviceSetupArray[e].remaccess, 'dallowance': new32bit, 'menuvisible': this.deviceSetupArray[e].menuvisible }
      this.sendUpdate( 'updatedeviceadvance', ctrlid, jsonData )
    },
    sendNew(who, content) {
      // console.log('...sending new ' + who)
      this.sendMicroServiceRequest({
        method: 'POST',
        url: 'api/authenticated/function/' + who,
        data: content
      })
      .then((response) => {
        if(response) {
          // console.log('i got new record response!')
          // console.log(JSON.stringify(response))
          if(response.data.createdevice[0].id) {
            this.makeToast(who + ' added!', 'success', 'b-toaster-top-right')
          } else {
            console.warn('...and it was an error: ' + JSON.stringify(response.data) )
            let createOutput = JSON.stringify(response.data.createdevice) || JSON.stringify(response.data.createuser)
            this.makeToast(createOutput + ' - try again', 'warning', 'b-toaster-top-center')
          }
        } else {
          console.error(JSON.stringify(response))
          this.makeToast(JSON.stringify(response) + ' No Response from Server!', 'warning', 'b-toaster-top-center')
        }

        this.refreshData(who)
    
      }).catch(error => console.error('caught! ' + error.message))
      
      // -- this shorter version *should* work, and tighter than the switch-case
      //      f.ex:  who = user
      //    let newWho = 'get' + who.charAt(0).toUpperCase() + who.slice(1) + 's'
      //    console.log(newWho)  --> 'getUsers' (f.ex.)
      //    global['newWho']()  --> same as calling getUsers()

    },
    refreshData(who) {
          // console.log('** Admin: refreshing data for ' + who)

          switch (who) {
            case 'createdevice':
            case 'updatedevice':
            case 'updatedeviceadvance':
              console.warn('** refreshing Devices')
              this.getWeatherStations()
              this.getZips()
              this.getDelays()
              this.getEmailSubjects()
              this.getDevices()
              break
            case 'createcompany':
            case 'updatecompany':
              console.warn('** refreshing Companies')
              this.getCompaniesDropdown()        
              this.getCompanies()
              break
            case 'createuser':
            case 'updateuser':
              console.warn('** refreshing Users')
              this.getUsers()
              break                   
            default:
              break
          }
    },
    onSubmit(who, content, event) {
      // console.log('...submitting new ' + who)

      if(who === 'createdevice') {
        // push rem-dall-menu stuff onto end of content
        content.remaccess = this.deviceSetupArray[content.featureOption].remaccess
        content.dallowance = this.deviceSetupArray[content.featureOption].dallowance
        content.menuvisible = this.deviceSetupArray[content.featureOption].menuvisible
      }
      // console.log(JSON.stringify(content, null , 2))
      this.sendNew(who, content)

      this.companyForm = {}
      this.userForm = {}
      this.deviceForm = {}

      // event.target.reset()
      this.refreshData(who)
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.companyForm = {}
      this.userForm = {}
      this.deviceForm = {}
      this.exportForm = {}
      // Trick to reset/clear native browser form validation state
      this.show = true
      this.$nextTick(() => {
        this.show = true
      })
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    onRowClickedLayout2(items) {
      this.selected = ''
      this.selectedItem = items
      this.getFeaturesRadioValue(this.selectedItem)

      this.getProcessIDs()   // temporary place?

      // alternate UI trick to bring focus to sidebar when row is clicked
      // var blinkbox = document.getElementById('blinkBox')
      // blinkbox.classList.add('blink_me')

      // setTimeout(function() { 
      //   blinkbox.classList.remove('blink_me')
      // }, 1000)

    },
    getFeaturesRadioValue(item) {
      // WORK IN PROGRESS!!  23.aug.2021  -jimm

      // console.warn('FIND ALL THE FEATURES')
      // console.log('from database:  { "remaccess": ' + JSON.stringify(item.remaccess)
      //                          + ', "dallowance": ' + JSON.stringify(item.dallowance)
      //                         + ', "menuvisible": ' + JSON.stringify(item.menuvisible) + ' }' )
      // var objectLength = Object.keys(item).length
      // console.log(objectLength)
      // for (var i = 0; i < objectLength; i++) {
      //   var el = item[i]
      //   console.log(i)
      //   if (el.remaccess == this.deviceSetupArray[i].remaccess && 
      //       el.dallowance == this.deviceSetupArray[i].dallowance && 
      //       el.menuvisible == this.deviceSetupArray[i].menuvisible) {
      //     console.log( '***** FOUND! ' + i )
      //     return i
      //   }
      // }
      // return -1



      // var data = this.deviceSetupArray,
      //     search = { 'remaccess': item.remaccess, 'dallowance': item.dallowance, 'menuvisible': item.menuvisible },
      //     keys = Object.keys(search),
      //     index = data.findIndex(a => Object.keys(a).length === keys.length && keys.every(k => a[k] === search[k]))
      // console.log(' ------------- radio index is: ' + index)
      // console.log(' ---- getFeaturesRadioValue()    search: ' + JSON.stringify(search))

      // return index
    },
    deviceConnectionValue(connType) {
      // return this.deviceConnectionDropDown.find(x => x.text == connType).value
      for (var i = 0; i < this.deviceConnectionDropDown.length; i++){
        if (this.deviceConnectionDropDown[i].text == connType){
          var deviceConnectionValue = this.deviceConnectionDropDown[i].value
          // console.log('deviceConnection return value found -> ' + deviceConnectionValue)
        }
      }
      return deviceConnectionValue
    },
    getProcessIDs() {
      // compare process_id to list of active or online ids we currently know about (prevent spoofing)
      
      Object.entries(this.dataDevices).forEach(([key, value]) => {
        if( value.active > 0 ) this.process_list.push(value.active)
        if( value.online > 0 ) this.process_list.push(value.online)
      })

      // console.log('process_list -> ' + JSON.stringify(this.process_list))      
    },
    convertToOptions(list = [], valueKey = '', labelKey = '') {
      return list.map(item => ({
          value: item[valueKey],
          text: item[labelKey]
        })
      )
    },

    assignDeviceToUser(ctrl_id, user_id) {
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: 'api/authenticated/function/assigndevicetouser',
        data: { touserid: user_id, ctrlid: ctrl_id }
      })
      .then((response) => {
        if(response) {
          // console.log(JSON.stringify(response))
        } else {
          console.error("something broke in assignDeviceToUser("+JSON.stringify(this.data)+")")
        }        
        this.getDevicesForUser( 'userid', user_id )        
      }).catch(console.error)      
    },    

    deleteDeviceFromUser(ctrl_id, user_id) {
      this.sendMicroServiceRequest({
        method: 'PUT',
        url: 'api/authenticated/function/deletecontrollerfromuser',
        data: { userid: user_id, ctrlid: ctrl_id }
      })
      .then((response) => {
        if(response) {
          // console.log(JSON.stringify(response))
        } else {
          console.error("something broke in deleteDeviceFromUser("+JSON.stringify(this.data)+")")
        }
        this.getDevicesForUser( 'userid', user_id )        
      }).catch(console.error)      
    },

    makeToast(message = 'something happened!', threat_level = 'info', position = 'b-toaster-top-right', append = true) {
      this.$bvToast.toast(message, {
        title: `${threat_level || 'default'}`,
        autoHideDelay: 5000,
        variant: threat_level,
        appendToast: append,
        solid: true,
        toaster: position
      })
    },
    csvExporter(section, section_name) {
 
      if(navigator.language) {
        console.log('i haz navigator.language: ' + navigator.language)
      }
      // let whereUser = this.ipLookUp()  // keep in case we want more accurate location later (see History export) -jimm 25.jul.2021
      let delimiter = ""
      let quotes = "\""

      // leaner variation of the History export code -jimm 26.jun.2021
      let country = navigator.language.slice(-2)
      switch(country) {
        case "DK":
        case "DE":
        case "NL":
        case "RO":
        case "IT":                
          console.log('i haz ' + country)
          delimiter = ";"
          break
        default:
          console.log('i haz default')
          delimiter = ","
          break
      }

      console.log('delimiter: ' + delimiter + ' / quotes: ' + quotes)

      const csvData = this.arrayToCSV(section, delimiter)

      const link = document.createElement('a')
      link.id = 'export-csv'
      link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csvData))
      link.setAttribute('download', `${section_name}_${this.getTimeStamp()}.csv`)

      document.body.appendChild(link)

      const btn = document.querySelector('#export-csv')
      btn.click()
      setTimeout(() => btn.remove(), 0)
    },
    arrayToCSV(objArray, delimiter) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      const lineEnd = '\r\n'

      //generate header line from first set of object keys
      let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(delimiter)}` + lineEnd

      // parse values of data into csv format enclosing everything in double quotes
      return array.reduce((str, data) => {
        str += `${Object.values(data).map(value => `"${value}"`).join(delimiter)}` + lineEnd
        return str
      }, str)
    },
    getTimeStamp() {
      const date = new Date()
      const region = navigator.language
      const dateOptions = {
        // weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      const timeOptions = {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
      }

      return date.toLocaleString(region, { ...timeOptions, ...dateOptions })
    },
    getLoremIpsumImage() {
      const { width, height } = this.exportImageProps
      let imageIndex = (this.loremIpsumImages[Math.floor(Math.random() * this.loremIpsumImages.length)])
      return `https://picsum.photos/${width}/${height}/?image=${imageIndex}`

    },
    isInt(value) {
      return !isNaN(value) && // it's a number
        parseInt(Number(value)) == value && // it's numerical integer version is the same as original value
        !isNaN(parseInt(value, 10))  // it's a base-10 numberical integer
    },  
  }
}
</script>

<style lang="scss">

.dummy {
  display: flex;
  flex-flow: column;
  height: 100%;
}

.blink_me {
  animation: blinker 0.2s 1;
}

@keyframes blinker {
  50% {
    border: 3px solid black;
  }
}

.b-table-row-selected {
  font-weight: bold;
}

$pagination-active-bg: #6c757d;

.page-item .page-link {
  color: #6c757d;
}

.page-item.active .page-link {
  background-color: #6c757d;
  border-color: #6c757d;
}

h1:focus, h2:focus, h4:focus { 
  border: 0px; 
  outline: -webkit-focus-ring-color auto 0px;
}
.dummy {
  padding: 5px;
}
.form-control::-webkit-input-placeholder {
  color: red;
}
.form-control:-moz-placeholder {
  color: red;
}
.form-control::placeholder {
  color: red;
}
.form-control:-ms-input-placeholder {
  color: red;
}

.modal-backdrop {
    z-index: 199;
}
.activeMonitorBox {
  width: 80px;
  display: inline-block;
  text-align: right;
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>